const getTerritoryPostsPageUrl = (territorySlug: string): string => `/t/${territorySlug}/explore/posts`;

export default getTerritoryPostsPageUrl;
